module.exports = __webpack_public_path__ + "img/patchyvideo.80ae4f27.svg";